import axios from "axios";

export const getProjectSpecialStatusAPI = (id) => {
  return axios.get("/ppm/project/getProjectSpecialStatus?id=" + id);
};

export const getExecutersAPI = (obj) => {
  // return axios.get(`getExecuters${params()}`);
  return axios({
    url: `ppm/project/getExecuters`,
    method: `get`,
    params: obj,
  });
};

export const getProjectStatusAPI = (id) => {
  return axios.get("/ppm/project/getProjectStatusListById?id=" + id);
};

export const createProjectEcrChangeAPI = (obj) => {
  return axios.post(`/ppm/project/createProjectEcrChange`, obj);
};

export const queryProjectOperationsAPI = (id) => {
  return axios.get(`/ppm/project/queryProjectOperations?id=${id}`);
};

export const getProjectStatusByIdAPI = (id) => {
  return axios.get(`ppm/project/getProjectStatusById?projectId=${id}`);
};


export const loadProjectTableAPI = (obj) => {
  return axios({
    url: `/ppm/project/loadTable`,
    method: "get",
    params: obj,
  });
};

export const urlList = [
  {
    id: 101,
    url: "/item",
  },
  {
    id: 104,
    url: "/changePage",
  },
  {
    id: 105,
    url: "/manufactPage",
  },
  {
    id: 106,
    url: "/manufactPartPage",
  },
  {
    id: 901,
    url: "/UserItem",
  },
  {
    id: 902,
    url: "/UserGroupItem",
  },
  {
    id: 401,
    url: "/quality",
  },
  {
    id: 301,
    url: "/project",
  },
  {
    id: 501,
    url: "/technology",
  },
  {
    id: 502,
    url: "/resource",
  },
];
